import { IMailingAddress } from "@smartrr/shared/entities/MailingAddress";
import { updateMatchInArray } from "@smartrr/shared/utils/updateMatchInArray";

import { CustomerSubReducer } from "@customer-app/state/typedCustomerRedux";

export interface IAddressesReducerState {
  addresses: IMailingAddress[];
  isLoading: boolean;
}

const initialState: IAddressesReducerState = {
  addresses: [],
  isLoading: true,
};

export const addressesReducer: CustomerSubReducer<IAddressesReducerState> = (state = initialState, action) => {
  switch (action.type) {
    case "LOADING_ADDRESSES": {
      return {
        ...state,
        isLoading: true,
      };
    }

    case "ERROR_LOADING_ADDRESSES": {
      return {
        ...state,
        isLoading: false,
      };
    }

    case "LOADED_ADDRESSES": {
      return {
        ...state,
        isLoading: false,
        addresses: action.payload.addresses,
      };
    }

    case "CREATED_CUSTOMER_ADDRESS": {
      return {
        ...state,
        isLoading: false,
        addresses: state.addresses.concat(action.payload.createdAddress),
      };
    }

    case "UPDATED_CUSTOMER_ADDRESS": {
      return {
        ...state,
        isLoading: false,
        addresses: updateMatchInArray(state.addresses, action.payload.updatedAddress, address => address.id),
      };
    }

    case "DELETED_CUSTOMER_ADDRESS": {
      return {
        ...state,
        isLoading: false,
        addresses: state.addresses.filter(address => address.id !== action.payload.deletedCustomerAddressId),
      };
    }

    default: {
      return state;
    }
  }
};
